export { renderDrawerBody as renderNavDrawerBody } from '../../Drawer/DrawerBody';
